/**
 * Format amount in cents as currency string using Intl.NumberFormat.
 * @param amountCents - Amount in smallest currency unit (cents)
 * @param currency - ISO 4217 currency code (e.g. 'CAD', 'USD'). Defaults to 'CAD'.
 */
export function formatMoney(amountCents: number, currency: string = "CAD"): string {
  const amount = amountCents / 100;
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: currency || "CAD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
